"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var banali_react_leaflet_1 = require("banali-react-leaflet");
var Choropleth = function (_a) {
    var marker = _a.marker;
    var map = banali_react_leaflet_1.useMap();
    react_1.useEffect(function () {
        map.fitBounds([marker]);
        map.setZoom(16);
    }, [map]);
    return null;
};
exports.default = Choropleth;
